import React from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight, Check } from "lucide-react";

export default function PaywallCard({ title, subtitle, features = [], compact = false }) {
  return (
    <div className={`card overflow-hidden ${compact ? "" : "max-w-2xl mx-auto"}`} data-testid="paywall-card">
      <div className="bg-[#2D332D] px-6 md:px-10 py-5 flex items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-[#3D453D] flex items-center justify-center text-[#D1A793]">
          <Lock size={18} strokeWidth={1.75} />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#9EAD94]">Premium</div>
          <div className="font-serif text-lg text-white leading-tight">Lifetime access · £29</div>
        </div>
      </div>
      <div className="p-8 md:p-10">
        <h3 className="font-serif text-2xl md:text-3xl text-[#2D332D] mb-3 leading-snug">{title}</h3>
        {subtitle && <p className="text-[#576056] leading-relaxed mb-6">{subtitle}</p>}
        {features.length > 0 && (
          <ul className="space-y-2.5 mb-8">
            {features.map((f, i) => (
              <li key={i} className="flex items-start gap-3 text-[15px] text-[#2D332D]">
                <div className="w-5 h-5 rounded-full bg-[#E9ECE8] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check size={12} className="text-[#6B7F62]" strokeWidth={2.5} />
                </div>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        )}
        <div className="flex flex-wrap gap-3 items-center">
          <Link to="/upgrade" data-testid="paywall-upgrade-cta" className="btn-primary">
            Unlock for £29 <ArrowRight size={17} />
          </Link>
          <span className="text-xs text-[#8A9488]">One-time · lifetime · no subscription</span>
        </div>
      </div>
    </div>
  );
}
